import { render, staticRenderFns } from "./EditBlock.vue?vue&type=template&id=0b563b01&scoped=true&"
import script from "./EditBlock.vue?vue&type=script&lang=js&"
export * from "./EditBlock.vue?vue&type=script&lang=js&"
import style0 from "./EditBlock.vue?vue&type=style&index=0&id=0b563b01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b563b01",
  null
  
)

export default component.exports